<template>
    <div class="page-title-area bg-4">
        <div class="container">
            <div class="page-title-content">
                <h2>Our Team</h2>
                <ul>
                    <li>
                        <router-link to="/">
                            Home 
                        </router-link>
                    </li>
                    <li class="active">Team</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PageTitle'
}
</script>